"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgKey(props) {
    return (React.createElement("svg", __assign({ viewBox: '0 0 16 16', xmlns: 'http://www.w3.org/2000/svg' }, props),
        React.createElement("path", { d: 'm8.5 6.82889.33333-.33312 7.16667 7.162v-.99935l-6.97017-6.96564c.08896-.35621.13684-.72869.13684-1.11243 0-2.52966-2.05204-4.58035-4.58334-4.58035s-4.58333 2.05069-4.58333 4.58035 2.05203 4.58035 4.58333 4.58035c.43147 0 .84847-.06087 1.2443-.17225l1.17236 1.1716h1.83333v1.66558h1.66667v1.66558h1.83333v1.83214h2.33333l.65625.67664.67708-.67664v-.99935l-7.5-7.49512zm-5-1.83214c-.82843 0-1.5-.67114-1.5-1.49902s.67157-1.49902 1.5-1.49902 1.5.67113 1.5 1.49902-.67157 1.49902-1.5 1.49902z' })));
}
exports.default = SvgKey;
